import header from "../../assets/header.png"

const Header = () => {
    return (
        <>
            <div className="relative overflow-hidden">
                <div className="relative pt-6 pb-16 sm:pb-24">
                    <div className="mt-8 mx-auto max-w-7xl px-4 sm:mt-24 sm:px-6">
                        <div className="text-center">
                            <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                                <span className="block">The one-stop hub for</span>
                                <span className="block text-brand">everything esports</span>
                            </h1>

                            <p className="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
                                Scoutli is a data analytics, scouting and team management platform for esports organizations. Think of it as the Moneyball approach to esports.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="relative">
                    <div className="absolute inset-0 flex flex-col" aria-hidden="true">
                        <div className="flex-1"/>
                        <div className="flex-1 w-full bg-brand"/>
                    </div>

                    <div className="max-w-7xl mx-auto px-4 sm:px-6">
                        <img
                            className="relative rounded-lg"
                            src={header}
                            alt="Header"
                        />
                    </div>
                </div>
            </div>

            <div className="bg-brand">
                <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
                    <h2 className="text-center text-white text-sm font-semibold uppercase tracking-wide">
                        Trusted by over 26,000 forward-thinking companies
                    </h2>

                    <div className="mt-8 grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-5">
                        <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                            <img className="h-12 brightness-0 invert" src="https://tailwindui.com/img/logos/tuple-logo-gray-400.svg"
                                 alt="Tuple"/>
                        </div>

                        <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                            <img className="h-12 brightness-0 invert" src="https://tailwindui.com/img/logos/mirage-logo-gray-400.svg"
                                 alt="Mirage"/>
                        </div>

                        <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                            <img
                                className="h-12 brightness-0 invert"
                                src="https://tailwindui.com/img/logos/statickit-logo-gray-400.svg"
                                alt="StaticKit"
                            />
                        </div>

                        <div className="col-span-1 flex justify-center md:col-span-3 lg:col-span-1">
                            <img
                                className="h-12 brightness-0 invert"
                                src="https://tailwindui.com/img/logos/transistor-logo-gray-400.svg"
                                alt="Transistor"
                            />
                        </div>

                        <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
                            <img
                                className="h-12 brightness-0 invert"
                                src="https://tailwindui.com/img/logos/workcation-logo-gray-400.svg"
                                alt="Workcation"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Header;